import { useCallback, useState } from 'react';

export const useToggle = () => {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen(!open), [open]);

  return { open, toggle, setOpen };
};
